import React from 'react';


import { makeStyles } from 'tss-react/mui';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import { AnnouncementNoticeBoardProps } from 'web-library/models/Announcements';
import { Box, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';
import NoticeBoardHeader from './NoticeBoardHeader';
import AnnouncementCard from './AnnouncementCard';

const useStyles = makeStyles()((theme) =>
({
  swiperContainer: {
    padding: theme.spacing(1),
    background: theme.color.background.bgHover01,
  },
  swiperHeader: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
  swiperSlide: {
    maxWidth: theme.spacing(35),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(6),
    paddingLeft: theme.spacing(1),
  },
  noAnnouncementMessage: {
    display: 'flex',
    height: theme.spacing(10),
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.color.text.textAccent,
    paddingBottom: theme.spacing(4),
  },
}));

const MobileNoticeBoard = ({
  announcementDetailPage: { content: announcementDetails, totalElements: totalAnnouncements },
  announcementConfig,
}: AnnouncementNoticeBoardProps) => {
  const { classes } = useStyles();

  const { t } = useTranslation();

  return (
    <Box className={classes.swiperContainer}>
      <Box className={classes.swiperHeader}>
        <NoticeBoardHeader totalAnnouncements={totalAnnouncements} />
      </Box>
      {totalAnnouncements ? (
        <Swiper pagination modules={[Pagination]} slidesPerView="auto">
          {announcementDetails.map((announcementDetail) => (
            <SwiperSlide key={announcementDetail.uuid} className={classes.swiperSlide}>
              <AnnouncementCard
                announcementDetail={announcementDetail}
                announcementConfig={announcementConfig}
                showReadMore
              />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <Typography className={classes.noAnnouncementMessage} variant="h3">
          {t('admin->>AnnouncementNoticeBoard.NoAnnouncementMessage')}
        </Typography>
      )}
    </Box>
  );
};

export default MobileNoticeBoard;
